import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default client (used by public + admin endpoints with the admin token)
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cec_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Customer client — caller passes Supabase access token explicitly
export const customerApi = {
  get: (path, token) =>
    axios.get(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } }),
  post: (path, body, token) =>
    axios.post(`${API}${path}`, body, { headers: { Authorization: `Bearer ${token}` } }),
};

export default api;
